import { fmtTL } from "../../lib/format";

// Önizleme: seçili personel, mevcut → yeni brüt/net (satır bazında kapsam dışı bırakılabilir)
export default function BulkRaisePreview({ rows, excluded, setExcluded, curOf, calc }) {
  const toggle = (id) => setExcluded(excluded.includes(id) ? excluded.filter((x) => x !== id) : [...excluded, id]);
  const allOn = excluded.length === 0;
  return (
    <div className="rounded-md border border-slate-200 overflow-auto max-h-64" data-testid="raise-preview">
      <table className="tbl text-xs w-full">
        <thead className="sticky top-0 bg-slate-50">
          <tr className="text-[10px] uppercase text-slate-600">
            <th className="px-2 py-1.5"><input type="checkbox" checked={allOn} onChange={() => setExcluded(allOn ? rows.map((p) => p.id) : [])} data-testid="raise-toggle-all" title={allOn ? "Tümünü kapsam dışı bırak" : "Tümünü seç"} /></th>
            <th className="text-left px-2 py-1.5">Adı Soyadı</th><th className="text-left px-2 py-1.5">Şube</th><th className="text-left px-2 py-1.5">Görevi</th><th className="text-left px-2 py-1.5">Şekli</th>
            <th className="text-right px-2 py-1.5">Mevcut Brüt</th><th className="text-right px-2 py-1.5">Yeni Brüt</th><th className="text-right px-2 py-1.5">Mevcut Net</th><th className="text-right px-2 py-1.5">Yeni Net</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((p) => {
            const cur = curOf(p), nv = calc(cur), off = excluded.includes(p.id);
            const up = (a, b) => (b > a ? "text-emerald-700 font-semibold" : b < a ? "text-red-700 font-semibold" : "text-slate-500");
            return (
              <tr key={p.id} className={`border-t border-slate-100 ${off ? "opacity-40" : ""}`} data-testid={`raise-row-${p.id}`}>
                <td className="px-2 py-1"><input type="checkbox" checked={!off} onChange={() => toggle(p.id)} data-testid={`raise-check-${p.id}`} /></td>
                <td className="px-2 py-1 whitespace-nowrap font-semibold">{p.full_name}</td><td className="px-2 py-1 whitespace-nowrap">{p.location_name || "—"}</td><td className="px-2 py-1 whitespace-nowrap">{p.duty || "—"}</td><td className="px-2 py-1">{cur.wage_basis || "Aylık"}</td>
                <td className="px-2 py-1 text-right">{fmtTL(cur.gross_salary || 0)}</td><td className={`px-2 py-1 text-right ${up(cur.gross_salary || 0, nv.gross)}`} data-testid={`raise-new-gross-${p.id}`}>{fmtTL(nv.gross)}</td>
                <td className="px-2 py-1 text-right">{fmtTL(cur.net_salary || 0)}</td><td className={`px-2 py-1 text-right ${up(cur.net_salary || 0, nv.net)}`} data-testid={`raise-new-net-${p.id}`}>{fmtTL(nv.net)}</td>
              </tr>
            );
          })}
          {rows.length === 0 && <tr><td colSpan={9} className="px-3 py-4 text-center text-slate-400">Kapsama giren personel yok</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
